import ErrorBlock from '@/components/error-block';

const ErrorPage = () => {
  return (
    <ErrorBlock
      text='Some issues have arisen in the theater'
      btnText='Click to re-enter'
      onClick={ () => window.location.href = '/m' }
    />
  );
};

export default ErrorPage;
